export default __webpack_public_path__ + "static/media/logo.c07a3f57.png";